export const BASE_PRACTITIONER_PATH = '/practitioners';

export const INDEX_PRACTITIONER_PATH = `${ BASE_PRACTITIONER_PATH }/all`;
export const NEW_PRACTITIONER_PATH = `${ BASE_PRACTITIONER_PATH }/new`;
export const EDIT_PRACTITIONER_PATH = `${ BASE_PRACTITIONER_PATH }/edit/:id`;
